<!-- Main Admin Layout Shell -->
<div class="admin-layout" [class.sidebar-open]="isSidebarExpanded">
  <!-- Mobile Sidebar Overlay -->
  <div class="sidebar-overlay" (click)="toggleSidebar()"></div>
  <!-- Left Navigation Sidebar -->
  <aside class="sidebar" [class.expanded]="isSidebarExpanded">
    <div class="logo-container">
      <div class="logo-box">
        <img src="https://cdn.alione.art/logo/alione_logo.svg" alt="logo" width="60">
      </div>
      <span class="logo-text" *ngIf="isSidebarExpanded">Admin Portal</span>
    </div>

    <nav class="nav-menu">
      @for (item of menuItems; track item.route) {
      <a [routerLink]="item.route" class="nav-item" [class.active]="isActive(item.route)"
        [title]="item.label | translate">
        <span class="nav-icon-wrapper">
          <i [class]="item.icon"></i>
          @if (item.badgeKey && getBadgeCount(item.badgeKey) > 0) {
          <span class="nav-badge">{{ getBadgeCount(item.badgeKey) > 99 ? '99+' : getBadgeCount(item.badgeKey) }}</span>
          }
        </span>
        <span class="nav-text" *ngIf="isSidebarExpanded">{{ item.label | translate }}</span>
      </a>
      }
    </nav>
  </aside>

  <!-- Right Content Area -->
  <div class="main-content">
    <header class="topbar">
      <div class="topbar-left">
        <button class="menu-toggle-btn" (click)="toggleSidebar()">
          <i class="pi pi-bars"></i>
        </button>
      </div>
      <div class="topbar-right">
        <!-- Language Toggle -->
        <!-- <button class="lang-toggle-btn" (click)="toggleLanguage()">
          <span class="lang-text">{{ currentLang }}</span>
        </button> -->

        <!-- <button class="notification-btn">
          <i class="pi pi-bell"></i>
          <span class="badge"></span>
        </button> -->

        <!-- User Profile Avatar and Menu in Topbar -->
        <div class="user-profile-topbar" (click)="op.toggle($event)">
          <div class="avatar topbar-avatar">
            <img
              [src]="currentUser()?.pictureUrl || ('https://ui-avatars.com/api/?name=' + (currentUser()?.fullName?.charAt(0) || currentUser()?.userName?.charAt(0) || 'A') + '&background=1f2937&color=fff')"
              alt="User Avatar" />
          </div>
        </div>

        <p-popover #op styleClass="user-profile-menu" [dismissable]="true" appendTo="body">
          <div class="profile-menu-header">
            <img
              [src]="currentUser()?.pictureUrl || ('https://ui-avatars.com/api/?name=' + (currentUser()?.fullName?.charAt(0) || currentUser()?.userName?.charAt(0) || 'A') + '&background=1f2937&color=fff')"
              alt="Avatar" class="menu-avatar" />
            <div class="user-info">
              <span class="user-name">{{ currentUser()?.fullName || currentUser()?.userName || 'Administrator' }}</span>
              <span class="user-email">&#64;{{ currentUser()?.userName || 'admin' }}</span>
            </div>
          </div>

          <p-divider></p-divider>

          <ul class="profile-menu-list">
            <li><a class="p-menuitem-link text-danger" (click)="logout(); op.hide()"><i class="pi pi-sign-out menu-icon"></i><span class="p-menuitem-text">{{
                  'HEADER.LOGOUT' | translate }}</span></a></li>
          </ul>
        </p-popover>
      </div>
    </header>

    <main class="page-content">
      <div class="content-wrapper">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
  <app-global-upload-progress></app-global-upload-progress>
</div>